import { render } from "./SelectedProductsGrid.vue?vue&type=template&id=d4627ed4&scoped=true"
import script from "./SelectedProductsGrid.vue?vue&type=script&lang=js"
export * from "./SelectedProductsGrid.vue?vue&type=script&lang=js"

import "./SelectedProductsGrid.vue?vue&type=style&index=0&id=d4627ed4&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/soilfood.com/soilfood.com/vue/oma-myyja/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4627ed4"]])

export default __exports__